
import React from 'react'
import { connectModal } from 'redux-modal'
import { Button, Modal } from 'react-bootstrap'

const ContractChangeRequired = ({ show, handleHide }) => {
  return (
    <Modal show={show}>
      <Modal.Header>
        <Modal.Title>Contract Update Required</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div>
          Since you have selected "Contract amended," you must update the contract details before saving (i.e., MLS number, property address, close date, or close amount).
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button onClick={handleHide}>OK</Button>
      </Modal.Footer>
    </Modal>
  )
}

const withModalHandlers = connectModal({ name: 'ContractChangeRequiredModal', destroyOnHide: true })

export const ContractChangeRequiredModal = withModalHandlers(ContractChangeRequired)
